import type { UnproxiedEditorSDK } from '../types'
import type { Logger } from '../logger'
import { wrapWithBreadcrumbs } from './wrapWithBreadcrumbs'

export const initEditorSDK = (logger: Logger, editorSDK: UnproxiedEditorSDK) =>
  wrapWithBreadcrumbs({
    editorSDK,
    onBreadcrumb: (bc: any) => logger.breadcrumb(bc),
  })
